import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import {Link} from 'react-router-dom'
import tw from "twin.macro";
import styled from "styled-components";

import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";
import {ReactComponent as StarIcon} from "feather-icons/dist/icons/star.svg";

//big
// const Container = tw.div`relative `;
// const Content = tw.div`w-full mx-auto py-5 lg:py-5 mt-16`;
// const HeadingWithControl = tw.div`flex flex-row items-center sm:items-stretch sm:flex-row justify-between -mx-1 mx-10 md:mx-10 -mt-56  md:-mt-64 lg:-mt-56`;
// const Icon =tw.img`lg:w-10 lg:h-10 xsm:w-8 xsm:h-8`
// const Text = tw.div` text-xs  text-gray-600`;
// const Year = tw.div`ml-2  text-xs  flex text-right text-yellow-600`;
// const TextInfo = tw.div`mx-2 p-2 md:p-0 bg-yellow-50`;
// const TitleReviewContainer = tw.div`flex flex-row justify-between sm:items-center xsm:-mt-2 lg:mt-0`;
// const Title = tw.h5`text-lg font-semibold`;
// const PlayImage=tw.img`w-16 h-16 mx-auto p-2 hover:p-1`
// const Rating = tw.span`ml-2 text-sm font-bold`;
// const IconWithText = tw.div`flex items-center`;
// const Card = tw.div`mx-auto xl:mx-0 xl:ml-auto max-w-sm p-2 lg:p-5 md:max-w-xs lg:max-w-sm xl:max-w-xs  -mt-20`;

// const ControlButton = styled(PrimaryButtonBase)`
//   ${tw`z-10`}
//   svg {
//     ${tw`w-24 h-24`}
//   }
// `;
// const PrevButton = tw(ControlButton)``;
// const NextButton = tw(ControlButton)``;

// const CardSlider = styled(Slider)`
//   ${tw`mt-1 xsm:mx-4 lg:mx-0`}
//   .slick-track {
//     ${tw`flex`}
//   }
//   .slick-slide {
//     ${tw` max-w-screen-xl justify-center pt-20 h-96 bg-yellow-50`}
//   }
// `;
// const CardImage = styled.div((props) => [
//   `background-image: url("${props.imageSrc}");`,
//   tw`max-w-screen-2xl flex items-center justify-center h-96 md:h-80 lg:h-96  bg-cover`,
// ]);
// const RatingsInfo = styled.div`
//   ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
//   svg {
//     ${tw`w-5 h-5 text-yellow-500 fill-current`}
//   }
// `;
// const YearInfo = styled.div`
//   ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
//   svg {
//     ${tw`w-5 h-5 text-yellow-500 fill-current`}
//   }
// `;

//small
const Container = tw.div``;
const Content = tw.div`w-full mx-auto  py-5 lg:py-5 mt-16`;
const HeadingWithControl = tw.div`flex flex-row z-50 items-center sm:items-stretch sm:flex-row justify-between lg:-mt-100`;
const Icon = tw.img`lg:w-10 lg:h-10 xsm:w-8 xsm:h-8`;
const Text = tw.div` lg:text-sm text-xxs line-clamp-2 lg:line-clamp-1 text-gray-600`;
const Year = tw.div`ml-2 lg:text-sm md:text-xxs text-xxxs truncate flex text-right text-yellow-600`;
const TextInfo = tw.div` py-2 md:py-1 lg:w-70 md:h-48 h-40 md:w-32 w-24`;
const TitleReviewContainer = tw.div`flex flex-row justify-between items-center lg:w-70 md:w-32 w-24  lg:mt-0`;
const Title = tw.h5`text-xxs lg:text-sm font-semibold line-clamp-1`;
const PlayImage = tw.img`w-16 h-16 mx-auto p-2 hover:p-1`;
const Rating = tw.span`ml-2 text-xxs lg:text-sm font-bold`;
const IconWithText = tw.div`flex items-center`;
const Card = tw.div`w-full mx-auto xl:mx-0 xl:ml-auto max-w-sm md:max-w-xs lg:max-w-sm xl:max-w-xs`;

const ControlButton = styled(PrimaryButtonBase)`
  ${tw`z-10 mx-5`}
  svg {
    ${tw`w-24 h-24`}
  }
`;
const PrevButton = tw(ControlButton)``;
const NextButton = tw(ControlButton)``;
const CardSlider = styled(Slider)`
  ${tw``}
  .slick-track {
    ${tw`flex items-center  justify-center`}
  }
  .slick-slide {
    ${tw` max-w-screen-xl flex items-center lg:w-40 justify-center`}
  }
`;
const CardImage = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw` flex items-center lg:rounded-md rounded-sm justify-center lg:h-90 lg:w-70 md:h-48 h-40   bg-cover`,
]);
const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4  sm:mt-0`}
  svg {
    ${tw`w-2 h-2 lg:w-3 lg:h-3 text-yellow-500 fill-current`}
  }
`;
const YearInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw` h-5 text-yellow-500 fill-current`}
  }
`;

export default ({ModalOpen,trailer}) => {
  const [sliderRef, setSliderRef] = useState(null);
  const sliderSettings = {
    arrows: false,
    slidesToShow: 6,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      

      {
        breakpoint: 900,
        settings: {
          slidesToShow: 5,
        },
      },
      
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 3,
        },
      },
   

      
    ],
  };

  return (
    <>
    <Container> 
      <Content>
        <CardSlider autoplaySpeed={4000} ref={setSliderRef} {...sliderSettings} >
            {trailer && trailer.map(item => 
            <Card key={item.id}>
              <CardImage imageSrc={item.cover_url} >
              <PlayImage onClick={()=>ModalOpen(item.trailer)} src={require("../../images/flximg/playButton.svg")}/>
              </CardImage>
             
              
              <TextInfo>
             
                <TitleReviewContainer>
                  <Title>{item.title}</Title>
                  {item.rating ? <RatingsInfo>
                    <StarIcon />
                    <Rating>{item.rating}</Rating>
                  </RatingsInfo>:<text></text>}
                </TitleReviewContainer>

                <TitleReviewContainer>
               {item.genre ?    <IconWithText>
                     <Text>{item.genre}</Text>
                  </IconWithText>: <text></text>}
                  <YearInfo>
                 <Year>{item.release_date}</Year>
                  </YearInfo>
                </TitleReviewContainer>
               
              </TextInfo>
            </Card>
           
          )}
        </CardSlider>
      </Content>
      
      <HeadingWithControl>
          
          <PrevButton onClick={sliderRef?.slickPrev}>
              <Icon src={require('../../images/flximg/back.svg')}/>
            </PrevButton>
       
          
            <NextButton onClick={sliderRef?.slickNext}>
            <Icon src={require('../../images/flximg/right.svg')}/>
            </NextButton>
      
        </HeadingWithControl>
      
    </Container>
   
    </>
  );
};
